import { State } from "./State";
import { Provinces } from "./Provinces";
import { useGetQuoteEstimateMutation } from "../store/api.slice";
import { useCallback } from "react";

export const getYear = () => {
  const date = new Date();
  return date.getFullYear();
};

export const toTitleCase = (str) => {
  if (!str || str.length === 0) return "";
  str = /[_&\\/# +()$~%.'":*?<>{}-]/g.test(str)
    ? str.replaceAll(/[_&\\/# +()$~%.'":*?<>{}-]/g, " ")
    : str;
  return str
    .trim()
    .split(" ")
    .map((word) =>
      word[0]
        ? word[0].toUpperCase() + word.substring(1).toLowerCase()
        : word + word.substring(1).toLowerCase()
    )
    .join(" ");
};

export const formatGoogleLocation = (payloadData) => {
  let responseObject = {};

  if (payloadData.length === 0) return responseObject;
  else {
    let ifExistCities = [],
      ifExistState = [];
    for (let each of payloadData["address_components"]) {
      let foundCity = Provinces.filter(
        (eachCity) =>
          each["long_name"].toLowerCase() === eachCity.city.toLowerCase()
      );
      let fountState = State.filter(
        (data) => each["long_name"].toLowerCase() === data.state.toLowerCase()
      );

      ifExistCities = ifExistCities.concat(foundCity);
      ifExistState = ifExistState.concat(fountState);
    }
    let city =
      ifExistCities.length > 0
        ? ifExistCities[0]["city"].toUpperCase()
        : "DEFAULT";
    let state = ifExistState.length > 0 ? ifExistState[0]["state"] : "DEFAULT";

    responseObject = {
      city,
      state,
      longitude: payloadData["geometry"]["longitude"],
      latitude: payloadData["geometry"]["latitude"],
      address: payloadData["address"],
    };

    return responseObject;
  }
};

export const formatGooglePredictions = (payloadData) => {
  return payloadData.map((item) => ({
    ...item,
    label: item.name,
  }));
};

export const truncateDecimalValue = (value) => {
  value = value.toString();
  const numberValue = value.split(".")[0];
  const suffixedNumber = value.split(".")[1].substring(0, 2);
  const decimalCount = value.split(".")[1].length;
  const prefixedNumber = Number(numberValue).toLocaleString();
  if (decimalCount > 2) value = `${prefixedNumber}.${suffixedNumber}`;
  else if (decimalCount < 2) value = `${prefixedNumber}.${suffixedNumber}0`;
  else
    value =
      suffixedNumber === "00"
        ? prefixedNumber
        : `${prefixedNumber}.${suffixedNumber}`;
  return value;
};

export const formatAmountValueToString = (data) => {
  const format = !data ? "0.00" : data;
  if (format.toString() === "0.00") return format.toLocaleString();
  else if (format.toString().includes(",")) {
    const newFormat = format.toString().replace(/,/g, "");
    const formattedNumber = parseFloat(newFormat);
    return formattedNumber.toLocaleString();
  } else if (format.toString().includes(".")) {
    const formatValue = truncateDecimalValue(format);
    return formatValue.toLocaleString();
  } else return `${format.toLocaleString()}`;
};

export const getUserJourneyDates = payload => {
	let userJourney = {};
	payload["user_journey"].map(item => (userJourney = {...userJourney, [item["system_status"]]: item["time"]}));
	return userJourney
}

export const formatInvoiceDetails = data => {
  let newArray = [], totalExtrasCharge = 0;
  
  if (!data.reference) data.reference = "NO REFERENCE";
  if (!data.user) data.user = {first_name: '', last_name: ''};
  let currency = (!data.quote.currency) ? "NGN" : data.quote.currency;
  
  if ( Object.keys(data.extras).length > 0) {
    for (const eachItem in data["extras"]) {
      if (data["extras"][eachItem] !== 0) {
        if(eachItem in data.quote) {
					let eachEntry = toTitleCase(eachItem);
					let eachEntryVal = [`${currency} ${formatAmountValueToString(Number(data.quote[eachItem]))}`];
					let entry = [eachEntry, eachEntryVal];
					newArray.push(entry);
					totalExtrasCharge += Number(data.quote[eachItem]);
				}
      }
    }
    
    let insuranceEntry = [["Insurance"], [`${currency} ${formatAmountValueToString(data.quote["estimated_insurance"])}`]];
    newArray.push(insuranceEntry);
  }
  
  let tripKey = [`Trip to destination (${data.category_size.tonnage} tonne ${data.category_size.category})`];
  let tripAmount = Number(data.quote["total_charge"]) - (Number(totalExtrasCharge) + Number(data.quote["vat_value"]));
	if(data.quote["estimated_insurance"]) tripAmount -= Number(data.quote["estimated_insurance"]);

	let tripValue = [`${currency} ${formatAmountValueToString(tripAmount)}`];
	let tripEntry = [tripKey, tripValue];
	newArray.push(tripEntry);

	let vatEntry = [["VAT"], [`${currency} ${formatAmountValueToString(Number(data.quote["vat_value"]))}`]];
	newArray.push(vatEntry);

	if(data.quote['discount_amount']) {
		let discountEntry = [["Discount"], [`- ${currency} ${formatAmountValueToString(Number(data.quote['discount_amount']))}`]];
		newArray.push(discountEntry);
  }

	return newArray;
  
};

////// *validator helpers* //////
export const preventPasteNegative = (event) => {
  const clipboardData = event.clipboardData || window.clipboardData;
  const pastedData = parseFloat(clipboardData.getData("text"));
  if (pastedData < 0) event.preventDefault();
};

export const validateIfFloat = (event) => {
  if (event.charCode === 101 || event.charCode === 45) event.preventDefault();
};

export const validateIfInteger = (event) => {
  if (
    event.charCode === 101 ||
    event.charCode === 46 ||
    event.charCode === 45 ||
    event.code === "Minus"
  )
    event.preventDefault();
};

export const trimPlaceholder = (text) => {
  if (text.length > 38) {
    return text.replace(/<[^>]*>?/gm, " ")
    .slice(0, 30) + '...'
  } else {
    return text;
  }
};


export const useEstimateCost = (setQuoteInfo, setQuoteInformation) => {
  const [getQuoteEstimate] = useGetQuoteEstimateMutation();

  const calculateEstimate = useCallback(
    async (params) => {
      const { vehicle, estimate, tripData, extras = {} } = params;

      if (!vehicle || !estimate) return;

      try {
        const payload = {
          trip_type: estimate.trip_type,
          category_size: vehicle.id,
          estimated_value: estimate.estimated_value,
          destination: estimate.destination,
          source: estimate.source,
          extras: extras,
        };

        const response = await getQuoteEstimate({
          payload,
          organisation: tripData.organisation.reference,
        });

        if (response?.data?.data) {
          setQuoteInfo?.(response.data.data);
          setQuoteInformation?.(response.data.data);
          return response.data.data;
        }

        throw new Error(response?.error?.data?.message || "Failed to get estimate");
      } catch (error) {
        setQuoteInfo?.("");
        setQuoteInformation?.("");
        throw error;
      }
    },
    [getQuoteEstimate, setQuoteInfo, setQuoteInformation] // dependencies
  );

  return calculateEstimate;
};


// export const useEstimateCost = (setQuoteInfo, setQuoteInformation) => {
//   const [getQuoteEstimate] = useGetQuoteEstimateMutation();

//   const calculateEstimate = async (params) => {
//     const { vehicle, estimate, tripData, extras = {} } = params;
    
//     if (!vehicle || !estimate) return;

//     try {
//       const payload = {
//         trip_type: estimate.trip_type,
//         category_size: vehicle.id,
//         estimated_value: estimate.estimated_value,
//         destination: estimate.destination,
//         source: estimate.source,
//         extras: extras
//       };

//       const response = await getQuoteEstimate({ 
//         payload, 
//         organisation: tripData.organisation.reference 
//       });

//       if (response?.data?.data) {
//         setQuoteInfo?.(response.data.data);
//         setQuoteInformation?.(response.data.data);
//         return response.data.data;
//       }
//       throw new Error(response?.error?.data?.message || "Failed to get estimate");
//     } catch (error) {
//       setQuoteInfo?.("");
//       setQuoteInformation?.("");
//       throw error;
//     }
//   };

//   return calculateEstimate;
// };


export const safeNumeric = (value) => {

  if(typeof value === "number" || typeof value === "bigint"){
    return value
  }

  if(typeof value === "string"){
    const _value = parseFloat(value)
    return isNaN(_value) ? 0 : _value
  }

  return 0

}